export default [
  {
    path: '/cpa-rs-performance-report',
    name: 'PageCpaRsPerformanceReportList',
    meta: {
      title: 'cpaRsPerformanceReport.listTitle',
      roles: ['ADMIN', 'TEAM_LEADER', 'AUDITOR'],
      permissions: ['cpa_rs_performance_report'],
    },
    component: () => import('@/pages/cpa-rs-performance-report'),
  },
] 
